<template>
  <div class="page-container" v-show="order.productName">
    <van-nav-bar class="buying-navbar" :title="productType == 2 ? '委托竞买成功' : '认购成功'" fixed />
    <div v-if="channel == 'wy'" class="page pt-20">
      <div class="ta-c">
        <img style="width: 15vw" src="../../assets/img/success-icon.png" />
      </div>
      <div class="ta-c color-golden fs-18 mt-10">您已购买成功</div>
      <div class="ta-c color-golden mt-5">
        关注“天安金交中心”公众号,可实时查询投资收益
      </div>
      <div class="px-20 mt-20 py-10" style="border-bottom: 1px solid #f2f2f2; overflow: hidden">
        <div class="fl">{{ order.productName }}</div>
        <div class="fr">{{ numFormat(order.amount) + "元" }}</div>
      </div>
      <div class="px-10 mt-10">
        <div class="steps">
          <div class="item fill">
            <div class="line">
              <img class="circle" src="../../assets/img/clock-icon.png" />
            </div>
            <div class="title">
              {{ productType == 2 ? "拍品收益到期日" : "收益到期日"
              }}{{ dateFormat(order.endTime, "YYYY年MM月DD日") }}
            </div>
          </div>
          <div class="item">
            <div class="line">
              <i class="circle"></i>
            </div>
            <div class="title">
              <div class="">
                {{ productType == 2 ? "预计成交日" : "起息日"
                }}{{ dateFormat(order.beginTime, "MM月DD日") }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <van-cell class="mt-20">
        <van-button class="confirm-ok" @click="$router.push({ name: 'invest' })" type="danger" round size="large">继续购买</van-button>
      </van-cell>
      <van-cell>
        <van-button class="confirm-cancel" @click="clickReturn" type="danger" round plain size="large">返回</van-button>
      </van-cell>
    </div>
    <div v-else class="page pt-20">
      <van-cell :title="productType == 2 ? '拍品名称' : '产品名称'" :value="order.productName" />
      <van-cell :title="productType == 2 ? '委托竞买额' : '购买金额'" :value="
          productType == 2
            ? numFormat(auctionPayAmount)
            : numFormat(order.amount) + '元'
        " />
      <van-cell :title="productType == 2 ? '预计成交日' : '起息日'" :value="order.beginTime" />
      <van-cell :title="productType == 2 ? '拍品到期日' : '到期日'" :value="order.endTime" />
      <van-cell :title="productType == 2 ? '折扣金额' : '预期收益'" :value="numFormat(order.returnAmount) + '元'" />
      <van-cell class="mt-20">
        <van-button class="confirm-ok" @click="$router.push({ name: 'invest' })" type="danger" round size="large">继续购买</van-button>
      </van-cell>
      <van-cell>
        <van-button class="confirm-cancel" @click="clickReturn" type="danger" round plain size="large">返回</van-button>
      </van-cell>
    </div>
    <van-popup v-if="order.score > 0" class="score-pop" v-model="popShow">
      <div class="container">
        <img class="bg" :src="require('@/assets/img/pay-success-pop.png')" />
        <div class="title">{{ order.score }}积分已到账</div>
        <div class="mt-30 ta-c">
          <van-button class="bg-color-orange-shop btn" type="warning" @click="popShow = false">确认</van-button>
        </div>
      </div>
      <!--<div class="close-wapper">
                <a class="close" href="javascript:" >
                    <img :src="require('@/assets/img/pay-success-pop-close.png')" >
                </a>
            </div>-->
    </van-popup>
    <redenvelope-pop :visible.sync="showRedenvelopePop" :createTime="order.serverTime" @onCloseClick="onCloseClick" @onOpenClick="onOpenClick"></redenvelope-pop>

    <anniversary-pop v-if="isShowAnniversary" :visible.sync="isShowAnniversary" :backgroundImg="order.sevenInfo ? order.sevenInfo.backgroundImg : ''" :title="order.sevenInfo ? order.sevenInfo.name : ''" :amount="parseInt(order.amount)" :currentAnnual="parseInt(order.currentAnnual)" :totalAnnual="parseInt(order.totalAnnual)" @onSureClick="onSureClick" />
    <van-popup class="tips-dialog" style="width: 100vw; background-color: transparent" :close-on-click-overlay="false" v-model="isShowDiscount">
      <div class="ta-c mt-15">
        <van-icon style="position: absolute; right: 10%; top: 0" name="close" size="25" color="white" @click="isShowDiscount = false" />
        <img style="margin-top: 30px; width: 100%; height: auto" src="../../assets/img/pop/discount_tips_bg.jpg" />
        <div style="
            position: absolute;
            display: flex;
            flex-direction: column;
            text-align: left;
            top: 35%;
            color: white;
            font-size: 14px;
            font-weight: 600;
            left: 17%;
            right: 15%;
          ">
          <div>尊敬的会员：</div>
          <div>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;您本次认购金额{{
              productType == 2
                ? (auctionPayAmount / 100).toFixed(0)
                : (order.amount / 100).toFixed(0)
            }}元，本次年化投资金额{{
              (order.currentAnnual / 100 || 0).toFixed(0)
            }}元；截止到今日，满足本月活动福利②项下的年化投资金额{{
              parseInt(yearDecAmount || 0)
            }}元。
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import session from "@/utils/session"
import * as OrderApi from "@/api/order"
import { mapActions, mapGetters } from "vuex"
import { NavBar, Button, Cell, Popup, Dialog, Icon } from "vant"
import RedenvelopePop from "../coupon/redenvelopePop.vue"
import { operationRedPacket } from "../../api/market"
import AnniversaryPop from "../anniversarycelebration/anniversaryPop.vue"
import { decAnnualYearAmount, junePostNotice, noticed } from "../../api/lottery"
export default {
  name: "paySuccess",
  data: () => ({
    investId: "",
    productType: 1, // 产品类型：1 资产 2 拍品
    auctionPayAmount: 0,
    order: {},
    returnUrl: "",
    popShow: true,
    showRedenvelopePop: false,
    isShowAnniversary: false,

    isShowDiscount: false,
    yearDecAmount: 0
  }),
  beforeMount() {
    session.del("payForm")
    this.investId = this.$route.query.investId
    this.productType = this.$route.query.productType
    this.auctionPayAmount = this.$route.query.auctionPayAmount

    OrderApi.getorder(this.investId)
      .then((data) => {
        this.order = data
        if (this.order.newYearId) {
          this.showRedenvelopePop = true
        } else {
          this.showAnniversary()
        }
        setTimeout(() => {
          this.loadJunePostNotice()
        }, 500)
        if (this.order.decActivity) {
          this.loadAnnualYearAmount()
        }
      })
      .catch((e) => { })
  },
  computed: {
    ...mapGetters(["os", "channel"])
  },
  methods: {
    ...mapActions(["getUserInfo"]),
    clickReturn() {
      this.$router.push({ name: "home", query: { chanlCode: this.channel } })
    },
    onOpenClick() {
      // 红包ID
      operationRedPacket(this.order.newYearId)
        .then((data) => {
          Dialog.confirm({
            title: "温馨提示",
            message:
              "恭喜您获得" + data + "积分，产品起息后可前往‘我的积分’列表查看",
            confirmButtonText: "确定"
          })
            .then(() => {
              this.showAnniversary()
            })
            .catch(() => {
              this.showAnniversary()
            })
        })
        .catch((e) => {
          this.$toast(e.msg || e.message)
        })
      this.showRedenvelopePop = false
    },
    onCloseClick() {
      this.showAnniversary()
    },
    showAnniversary() {
      if (this.order.sevenCelebration && this.order.sevenInfo) {
        this.isShowAnniversary = true
      } else {
        this.updateUserInfo()
      }
    },
    onSureClick() {
      this.updateUserInfo()
    },
    updateUserInfo() {
      this.getUserInfo().then((userInfo) => {
        if (userInfo.aprilOutingLottery) {
          this.closeLotteryTips()
          this.$router.push({
            name: "aprilLotter",
            query: { paySuccessEnter: true }
          })
        }
      })
    },
    closeLotteryTips() {
      noticed().then((data) => { })
      this.getUserInfo()
    },
    loadJunePostNotice() {
      junePostNotice(this.investId)
        .then((data) => {
          if (data) {
            this.$router.push({
              name: "sixLotter",
              query: { paySuccessEnter: true }
            })
          }
        })
        .catch((e) => {
          console.log(e.msg || e.message)
        })
    },
    loadAnnualYearAmount() {
      decAnnualYearAmount()
        .then((data) => {
          this.isShowDiscount = true
          this.yearDecAmount = data || 0
        })
        .catch((e) => { })
    }
  },

  components: {
    RedenvelopePop,
    [NavBar.name]: NavBar,
    AnniversaryPop,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [Popup.name]: Popup,
    [Dialog.name]: Dialog,
    [Icon.name]: Icon
  }
}
</script>

<style scoped lang="less">
.page-container {
  box-sizing: border-box;
  height: 100%;
  background-image: url("../../assets/img/home/footer-bg.png");
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center 85%;
  background-size: 60vw auto;
}
.page {
  background: #fff;
}

.van-cell__title {
  color: @gray-dark;
}
.van-cell__value {
  color: @dark;
}
.steps {
  padding-left: 32px;
  .item {
    position: relative;
    line-height: 40px;
    .title {
    }
    .line {
      position: absolute;
      top: 15px;
      left: -15px;
      width: 1px;
      height: 105%;
      background-color: @red;
      .circle {
        position: absolute;
        top: 6px;
        left: 0;
        width: 6px;
        height: 6px;
        border: 1px solid @red;
        border-radius: 50%;
        transform: translate(-50%, -50%);
        background: #fff;
      }
    }
  }
  .item.fill {
    .line {
      .circle {
        background: #fff;
        width: 16px;
        height: auto;
        border: none;
      }
    }
  }
  .item:first-child {
  }
  .item:last-child {
    .line {
      border-color: transparent;
      background-color: transparent;
    }
  }
}
.score-pop {
  background: transparent;
  .container {
    background: #fff;
    width: 75vw;
    position: relative;
    .bg {
      width: 100%;
      height: auto;
    }
    .title {
      position: absolute;
      top: 50px;
      left: 0;
      width: 100%;
      font-size: 24px;
      color: #fff;
      text-align: center;
    }
    .btn {
      width: 150px;
      line-height: 40px;
      height: 40px;
      font-size: 18px;
      margin-bottom: 30px;
    }
  }
  .close-wapper {
    text-align: center;
    margin-top: 50px;

    img {
      width: 50px;
    }
  }
}
</style>
